import Lottie from "react-lottie";
import { useContext } from "react";

import { TransferContext } from "../../context/TransferContext";

import ScrollableContainer from "../../layout/scrollable-container";
import TransitionWrapper from "../../components/transition-wrapper/TransitionWrapper";
import { STEP_IRA_EXIT_SCREEN } from "../../class/transferDetails";
import * as Styled from "../post-transfer/styles";
import transferCheckAnimation from "./assets/steps animation_mariner version.json";
import { HeadlineMedium } from "../../components/font";

const OpenIRAAnimationPane = () => {
  const { goToScreen } = useContext(TransferContext);
  const onNext = () => goToScreen(STEP_IRA_EXIT_SCREEN);
  return (
    <TransitionWrapper>
      <ScrollableContainer name="transfer-check-screen">
        <Styled.TransferCheckContainer $narrow={false} $fullHeight={false}>
          <TransitionWrapper>
            <HeadlineMedium $textAlign="center">We’re running 25+ checks on your transfer details</HeadlineMedium>
          </TransitionWrapper>
          <Styled.AnimationWrapper>
            <Lottie
              options={{
                loop: false,
                autoplay: true,
                animationData: transferCheckAnimation,
              }}
              style={{ width: 300, height: 400 }}
              eventListeners={[
                {
                  eventName: "complete",
                  callback: onNext,
                },
              ]}
            />
          </Styled.AnimationWrapper>
        </Styled.TransferCheckContainer>
      </ScrollableContainer>
    </TransitionWrapper>
  );
};

export default OpenIRAAnimationPane;
